import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { receive, loadError, showMiniCart } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { add as addToCartService} from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { getQueryParameter } from '../Services/utilities';
import { setSelectedSizeByName, showSizePicker } from '../Actions/SizePicker.action';

const BuyButtonContainer = props => {
    const { isInStock, articleNumber, onClick, showSizePicker, sizePickerVisible, setSizeFromQuery, selectedSizeItem, hideVariantSelect } = props

    const [addToCartAfterSizePicker, setAddToCartAfterSizePicker] = useState(false)

    // Pre-set the size based on the query parameter
    useEffect(() => {
        if (hideVariantSelect) {
            return;
        }

        var querySize = getQueryParameter("size")
        if(querySize) {
            setSizeFromQuery(querySize)
        }
    }, [])

    useEffect(() => {
        if(!hideVariantSelect && selectedSizeItem && !sizePickerVisible && addToCartAfterSizePicker) {
            onClick(selectedSizeItem.articleNumber, props.quantityFieldId)
        }
    }, [sizePickerVisible])

    // Set correct size in the URL
    useEffect(() => {
        if (hideVariantSelect) {
            return;
        }

        if(!selectedSizeItem) return

        var querySize = getQueryParameter("size")
        if(!querySize || querySize.toLowerCase() != selectedSizeItem.size.toLowerCase()) {
            var url = new URL(window.location)
            url.searchParams.set("size", selectedSizeItem.size)
            window.history.pushState("sizeSelected", document.title, url)
        }
    }, [selectedSizeItem])

    return <>
        <BuyButton
            cssClass={props.cssClass}
            label={props.label}
            href={props.href}
            showSizePicker={addToCartAfter => { showSizePicker(); setAddToCartAfterSizePicker(addToCartAfter) }} 
            selectedSizeItem={selectedSizeItem}
            onClick={() => {
                const selectedArticleNumber = !hideVariantSelect && selectedSizeItem ? selectedSizeItem.articleNumber : articleNumber;
                return selectedArticleNumber && onClick(selectedArticleNumber, props.quantityFieldId);
            }}
            onSuccess={props.onSuccess}
            onError={props.onError}
            isInStock = {isInStock === true || isInStock == "true"}
            articleNumber={props.articleNumber}
            outOfStockLabel={props.outOfStockLabel}
            hideVariantSelect={hideVariantSelect}
        />
    </>
}

const mapStateToProps = state => {
    return {
        selectedSizeItem: state.sizePicker.selectedSizeItem,
        sizePickerVisible: state.sizePicker.visible,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSuccess: (cart) => {
            dispatch(receive(cart));
            dispatch(showMiniCart())
        },
        onError: (ex) => {
            dispatch(catchError(ex, error => loadError(error)));
        },
        showSizePicker: () => dispatch(showSizePicker()),
        setSizeFromQuery: size => dispatch(setSelectedSizeByName(size))
    }
}

const onClick = (articleNumber, quantityFieldId) => {
    const quantity = quantityFieldId ? document.getElementById(quantityFieldId).value : 1;
    return addToCartService(articleNumber, quantity);
}
export default connect(mapStateToProps, mapDispatchToProps)(
            withReactiveStyleBuyButton(BuyButtonContainer, onClick, 'buy-button-container'));
